import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function numberFormat(
  num: number | bigint | Intl.StringNumericLiteral,
): string {
  return new Intl.NumberFormat().format(num);
}

function murmurHash(string: string) {
  let hash = 0x811c9dc5; // 初期値 (FNV-1a)
  for (let i = 0; i < string.length; i++) {
    hash ^= string.charCodeAt(i);
    hash = Math.imul(hash, 0x01000193); // FNV プライム
  }
  return hash >>> 0; // 32-bit unsigned int
}

export function stringToColor(
  string: string,
  options?: {
    saturation?: number;
    lightness?: number;
    opacity?: number;
  },
) {
  const hash = murmurHash(string);
  const hue = hash % 360;

  const saturation = options?.saturation ?? 70;
  const lightness = options?.lightness ?? 50;
  const opacity = options?.opacity;

  return `hsl(${hue} ${saturation}% ${lightness}%${opacity ? ` / ${opacity}` : ""})`;
}
